<div class="mt-4">
    <ca-accordion class="ca-accordion-content">
        <ca-accordion-item class="ca-accordion--filter" [openItem]="toggAcBusqueda" (toggle)="toggAcBusqueda =! toggAcBusqueda">
			<div ca-accordion-header data-cy="accordion-header" >
				<h3 class="ca-accordion-title">{{'BUSCADOR_POLIZAS.BUSCAR_CABECERA' | translate}}</h3>
				<span class="ca-accordion-icon material-icons" *ngIf="toggAcBusqueda">keyboard_arrow_up</span>
				<span class="ca-accordion-icon material-icons" *ngIf="!toggAcBusqueda">keyboard_arrow_down</span>
			</div>
            <div ca-accordion-body class="ca-accordion__body" data-cy="accordion-body">
                <form [formGroup]="buscarForm" (ngSubmit)="buscar()">
                    <div class="row"> 
                        <ca-form-field class="col-4">
                            <ca-label>{{'BUSCADOR_POLIZAS.NUM_POLIZA' | translate}}</ca-label>
                            <input caInput formControlName="nPoliza" placeholder="{{'BUSCADOR_POLIZAS.NUM_POLIZA' | translate}}" type="number"/>
                            <ca-hint>{{'BUSCADOR_POLIZAS.HINT_POLIZA' | translate}}</ca-hint>
                        </ca-form-field>
                        <ca-form-field class="col-4">
                            <ca-label>{{'BUSCADOR_POLIZAS.NUM_COLECTIVA' | translate}}</ca-label>
                            <input caInput formControlName="nColectiva" placeholder="{{'BUSCADOR_POLIZAS.NUM_COLECTIVA' | translate}}" type="number"/>
                            <ca-hint>{{'BUSCADOR_POLIZAS.HINT_COLECTIVA' | translate}}</ca-hint>
                        </ca-form-field>
                    </div>
                    <div class="row mt-5"> 
                        <ca-form-field class="col-4">
                            <ca-label>{{'BUSCADOR_POLIZAS.DOCUMENTO' | translate}}</ca-label>
                            <input caInput formControlName="documento" placeholder="{{'BUSCADOR_POLIZAS.DOCUMENTO' | translate}}" type="text"/>
                            <ca-hint>{{'BUSCADOR_POLIZAS.HINT_DOCUMENTO' | translate}}</ca-hint>
                       </ca-form-field>
                    </div>
                    <div class="row mt-5">
                        <div class="col-4">
                            <ca-form-field >
                                <ca-label>{{ 'BUSCADOR_POLIZAS.FECHA_EMISION_DESDE' | translate }}</ca-label>
                                <ca-datepicker formControlName="fEmiDesde" name="fEfectoDatepicker"> </ca-datepicker>
                            </ca-form-field>
                            <ca-error *ngIf="buscarForm.controls['fEmiDesde'].errors?.pattern">{{'ERROR.ERROR_FORMATO_FECHA' | translate}}</ca-error>
                        </div>
                        <div class="col-4">
                            <ca-form-field >
                                <ca-label>{{ 'BUSCADOR_POLIZAS.FECHA_EMISION_HASTA' | translate }}</ca-label>
                                <ca-datepicker formControlName="fEmiHasta" name="fEfectoDatepicker"> </ca-datepicker>
                            </ca-form-field>
                            <ca-error *ngIf="buscarForm.controls['fEmiHasta'].errors?.pattern">{{'ERROR.ERROR_FORMATO_FECHA' | translate}}</ca-error>
                        </div>
                    </div>
                    <ca-form-field class="row col-4 mt-4">
                        <ca-label>{{'BUSCADOR_POLIZAS.ESTADO' | translate}}</ca-label>
                        <ca-select 
                            [options]="estados"
                            keyValue="descEstado"
                            valueField="codEstado"
                            [value]="busqueda?.estado"
                            formControlName="estado"></ca-select>
                        <ca-error *ngIf="buscarForm.controls['estado'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
                    </ca-form-field>
                    <div class="col-12 text-right mt-3 mb-3">
						<button type="submit" ca-button class="ca-btn-icon__container ml-2" data-cy="button-search">
							<ca-icon>search</ca-icon>
							{{'BUSCADOR_POLIZAS.BOTON_BUSCAR' | translate}}
						</button>
					</div>
                </form>
            </div>
        </ca-accordion-item>
        <ca-accordion-item class="ca-accordion--result" [openItem]="toggAcResultado" (toggle)="toggAcResultado =! toggAcResultado"
            *ngIf="solicitudes && solicitudes.length > 0">
            <div ca-accordion-header data-cy="accordion-header" >
				<h3 class="ca-accordion-title">{{'BUSCADOR_POLIZAS.RESULTADO_CABECERA' | translate}}</h3>
				<span class="ca-accordion-icon material-icons" *ngIf="toggAcResultado">keyboard_arrow_up</span>
				<span class="ca-accordion-icon material-icons" *ngIf="!toggAcResultado">keyboard_arrow_down</span>
			</div>
            <div ca-accordion-body class="ca-accordion__body" data-cy="accordion-body">            
                <ca-tabla-seguros 
                    [registros]="registros" 
                    [columnas]="columnas" 
                    [tamanoPagina]="10" 
                    [paginado]="true" 
                    [registroSeleccionable]="true"
                    (registroSeleccionadoEvent)="seleccionarRegistro($event)"></ca-tabla-seguros>  
                <div class="col-12 text-right mt-3 mb-3">
                    <button ca-button class="ca-btn-icon__container ml-2" (click)="verDetallePoliza()" [disabled]="!solicitudSeleccionada">
                        <ca-icon>chevron_right</ca-icon>
                        {{'BUSCADOR_POLIZAS.BOTON_CONTINUAR' | translate}}                        
                    </button>
                </div>
            </div>
        </ca-accordion-item>
    </ca-accordion>
</div>